<script>
  import { createEventDispatcher } from 'svelte';
  // noinspection ES6UnusedImports
  import { slide } from 'svelte/transition';
  import LoginBackground from './LoginBackground.svelte';
  import { tv2Logo } from './Icons';
  import { activeView, loginStore } from './loginStore';
  import { addAlias, checkAlias, loginAnonymously } from '../../Api/api';
  import { firebaseApp } from '../../Store/firebase-store';
  import Spinner from '../Common/Spinner.svelte';
  import { channel } from '../Chat/chat-store';

  const dispatch = createEventDispatcher();

  let showSpinner = false;

  $: news = $channel && $channel.category === 'news';
  $: sport = $channel && $channel.category === 'sport';
  $: entertainment = $channel && $channel.category === 'entertainment';
  $: spinnerColor = $channel && (news || entertainment || sport) ? '#fafafa' : '#222222';

  const doValidateAlias = async (alias) => {
    try {
      const msg = validateAlias(alias);
      if (msg) {
        return msg;
      }
      const res = await checkAlias(alias, $firebaseApp);
      if (!res.empty) {
        return 'Alias er tatt.';
      }
    } catch (e) {
      console.log(e);
      return 'Ukjent feil under validering av alias.';
    }
  };

  const onLoginAnonymously = async () => {
    const alias = $loginStore.tempChatAlias;
    const aliasValidationErrorMsg = await doValidateAlias(alias);
    if (aliasValidationErrorMsg) {
      $loginStore.errorMessage = aliasValidationErrorMsg;
      return;
    }
    try {
      showSpinner = true;
      const { user } = await loginAnonymously($firebaseApp);
      await addAlias(user.uid, alias, $firebaseApp);
      await user.updateProfile({ displayName: alias });
      dispatch('user-has-alias');
    } catch (e) {
      console.log(e);
      $loginStore.errorMessage = 'Kunne ikke logge inn.';
    } finally {
      showSpinner = false;
    }
  };

  const validateAlias = (alias) => {
    if (alias.length <= 1) {
      return 'Alias må være minst to karakterer';
    } else if (alias.length > 20) {
      return 'Alias kan ikke være lengre enn 20 karakterer';
    }
    return '';
  };
</script>

<div class="anonymous-login-container" class:news class:sport class:entertainment in:slide>
  <LoginBackground
    icon={tv2Logo}
    backgroundColor={$channel && (news || entertainment || sport) ? '#100118' : ''}
    on:close={() => loginStore.close()}
  />
  <div class="content">
    {#if showSpinner}
      <div class="spinner">
        <Spinner color={spinnerColor} />
      </div>
    {:else}
      <h1 class="sumo-user-label">Velkommen inn!</h1>
      <h1 class="sumo-user-label">Hva skal vi kalle deg?</h1>
      {#if $loginStore.errorMessage}
        <div class="error">{$loginStore.errorMessage}</div>
      {/if}
      <input
        type="search"
        autocomplete="off"
        id="alias"
        name="alias"
        placeholder="Chat-kallenavn (alias)"
        bind:value={$loginStore.tempChatAlias}
        on:change={() => loginStore.setErrorMessage('')}
      />

      {#if $channel && !$channel.political}
        <span class="loginInfo"
          >Ønsker du å beholde kallenavnet ditt til evig tid, kan du <button
            on:click={() => loginStore.setActiveView(activeView.SUMO_LOGIN)}>logge inn</button
          >
          eller
          <a class="href" href="https://play.tv2.no/ny-bruker"> registrere en bruker </a></span
        >
      {/if}

      <button on:click={onLoginAnonymously} class="joinChatBtn">Bli med i chatten </button>
    {/if}
  </div>
</div>

<style src="./anonymous.scss"></style>
